import styled from 'styled-components';
import { DisableSelection } from '../../styles/stylesStyled';

export const MavieRank = styled.div<{ isNext: boolean }>`
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  ${(props) => props.isNext && '-webkit-filter: grayscale(1); opacity: .5'};
  width: 100%;
  display: flex;

  flex-direction: column;
  > div {
    width: 100%;
    padding: 12px 24px;
  }
  > img {
    width: 100%;
  }
  border-radius: 25px;
  position: relative;

  @media (max-width: 800px) {
    border-radius: 8px;

    > div {
      padding: 15px 15px;
    }
  }

  overflow: hidden;
  background: ${(props) => props.theme.colors.neutral50};
`;

export const RankStatus = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
  border-radius: 5px;
  @media (max-width: 800px) {
    bottom: 15px;
    right: 15px;
  }
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  margin-left: 10px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex: none;
`;

export const CountdownNumbers = styled.div`
  display: flex;
  align-items: flex-end;
  margin-left: 5px;
`;

export const RankImage = styled.div<{
  isDisabled: boolean;
  image: any;
  imageHeight?: string;
  imageHeightSM?: string;
}>`
  position: relative;
  display: flex;
  padding: 50px;
  background-image: ${({ image }) => `url(${image}) `};
  background-color: #000;
  background-size: cover;
  background-repeat: no-repeat;

  height: ${({ imageHeight }) => imageHeight || '120px'};

  ${({ isDisabled }) =>
    isDisabled &&
    `
   ::before {
    background: rgba(130, 130, 130, 0.56);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  `}

  @media (max-width: 800px) {
    padding: 0;
    /* align-items: center; */
    height: ${({ imageHeightSM }) => imageHeightSM || '100px'};
  }
`;

export const Button = styled.button<any>`
  border: none;
  font-size: 15px;
  font-weight: 700;

  height: 40px;
  border-radius: 8px;
  width: ${({ w }) => (w ? w : '100%')};
  cursor: pointer;
  font-size: ${(props) => props.theme.buttonFontSize};

  color: ${(props) =>
    props.negative
      ? props.theme.colors.neutral900
      : props.theme.colors.neutral0};
  ${({ color }) => color && `background-color: ${color}`};

  ${(props) => props.textColor && `color: ${props.textColor};`}

  border: ${(props) =>
    props.negative ? `1px solid ${props.theme.colors.neutral900}` : 'none'};

  ${(props) => props.disabled && `cursor: not-allowed`};

  ${(props) => props.fs && `font-size: ${props.fs}`};

  height: ${(props) => props.h};
  padding: ${(props) => props.p};

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  max-width: ${(props) => props.maxWidth};

  ${({ condensed }) =>
    condensed &&
    `
    height: 33px; 

  `}

  ${({ negativeLight, theme }) =>
    negativeLight &&
    `
    border: 1px solid ${theme.colors.neutral0};
    color: ${theme.colors.neutral0};
    background: none;

  `}

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;

    max-width: ${(props) => props.maxWidthSM};
    width: ${(props) => (props.wSM ? props.wSM : '100%')};
  }

  ${({ textButton, theme }) =>
    textButton &&
    `
    background-color: rgba(0,0,0,0);
    color: ${theme.colors.neutral900};
    font-weight: 700;
    border: none;
  `}

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }
`;
